import React, {Fragment, useEffect, useState} from 'react';

import '../../App.css';
import {Button, Col, Flex, Row, Typography} from "antd";
import {Components, groupComponents} from "../common/Components";
import {Component as ComponentField} from "../../feature/project/setting";
import {useAppDispatch, useAppSelector} from "../../feature/tools";
import {fetchGlobalSetting} from "../../feature/project/settingsSlice";
import {useCookies} from "react-cookie";
import {ItemType} from "rc-collapse/es/interface";
import {useNavigate, useParams} from "react-router-dom";
import {ComponentDetails} from "../common/ComponentDetails";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPlus} from "@fortawesome/free-solid-svg-icons";
import {AddComponentModal} from "../common/AddComponentModal";
import {fetchTags} from "../../feature/project/projectsSlice";
import {saveSettingComponent} from "../../feature/project/componentsSlice";
import {Status} from "../../feature/project/status";
import {ViewMode} from "../common/ViewMode";

const ProjectSetting = () => {
    const dispatch = useAppDispatch()
    const {componentId} = useParams();
    const [cookies] = useCookies(['componentView']);
    const navigate = useNavigate()
    const project = useAppSelector(state => state.projects.project)
    const setting = useAppSelector(state => state.settings.projectSetting)
    const status = useAppSelector(state => state.settings.status)
    const categories = useAppSelector(state => state.categories.categories)
    const [items, setItems] = useState<ItemType[]>([])
    const [modal, setModal] = useState<number | undefined>(undefined)

    useEffect(() => {
        if ((status === Status.Idle || !setting || project?.settingId !== setting?.id) && project?.settingId && project?.id) {
            dispatch(fetchGlobalSetting({projectId: project?.id, settingId: project.settingId}))
            dispatch(fetchTags({projectId: project?.id || 0}))
        }
    }, [project, status, setting, dispatch])


    useEffect(() => {
        const items: ItemType[] = groupComponents(
            setting?.components || [],
            cookies['componentView'] === ViewMode.List,
            `/projects/${project?.id}/setting/components/`
        )
        setItems(items)
    }, [cookies['componentView'], setting, dispatch])


    return (
        <Row style={{height: "100%"}}>
            <Col span={componentId ? 16 : 24} style={{height: "100%"}}>
                <Components
                    title={'Global Setting Components'}
                    categories={categories?.filter((item) => item.type === 'setting' || item.type === 'any') || []}
                    onAddComponentClick={(key: number) => setModal(key)}
                    onBackClick={() => navigate(`/projects/${project?.id}`)}
                />
                <div style={{
                    marginTop: 20,
                    marginLeft: '-18px',
                    padding: '0 18px 18px 18px',
                    overflowY: 'auto', scrollbarWidth: "none",
                    overflowX: 'visible',
                    height: 'calc(100% - 60px)',
                    width: 'calc(100% + 36px)'
                }}>
                    {
                        items.map((item: ItemType, index: number) =>
                            <Fragment key={item.key}>
                                <Flex key={item.key} justify={'space-between'} align={'center'}><Typography style={{
                                    fontWeight: 700,
                                    marginTop: index > 0 ? 16 : 0,
                                    marginBottom: 16
                                }}>{item.label}
                                </Typography>
                                    <Button type={'text'}
                                            onClick={() => setModal(item.key ? parseInt(item.key?.toString()) : undefined)}>
                                        <FontAwesomeIcon icon={faPlus}/>
                                    </Button>
                                </Flex>
                                {item.children}
                            </Fragment>
                        )
                    }
                </div>
            </Col>
            {componentId ? <Col span={8} style={{height: "100%"}}>
                <ComponentDetails
                    component={setting?.components?.find((item) => item.id?.toString() === componentId)}
                    onAddComponent={
                        (component: ComponentField) => {
                            if (setting?.id && project?.id) {
                                dispatch(saveSettingComponent({
                                    settingId: setting?.id,
                                    projectId: project?.id,
                                    component: component
                                }))
                            }
                        }
                    }
                    onClose={() => navigate(`/projects/${project?.id}/setting`)}
                />
            </Col> : ''}
            {setting ? <AddComponentModal
                component={{title: '', description: '', tags: [], category: (categories?.find((item) => item.id === modal))}}
                visible={modal !== undefined}
                onCancel={() => setModal(undefined)}
                onSave={(component: ComponentField) => {
                    if (setting?.id && project?.id) {
                        dispatch(saveSettingComponent({
                            settingId: setting?.id,
                            projectId: project?.id,
                            component: component
                        }))
                    }
                    setModal(undefined)
                }}
            /> : ''}
        </Row>
    );
};

export default ProjectSetting;